"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var SliderSettings = /*#__PURE__*/function () {
  function SliderSettings(component) {
    var _this = this;
    _classCallCheck(this, SliderSettings);
    this.component = void 0;
    this.onSliderInit = function () {
      var _this$component$props;
      _this.component.setState({
        currentSlide: _this.component.props.startingSlide || 0,
        playing: !!((_this$component$props = _this.component.props.autoPlay) !== null && _this$component$props !== void 0 && _this$component$props.active),
        slidesToShow: _this.component.props.slidesToShow.xl,
        slidesToScroll: _this.component.props.slidesToScroll.xl || _this.component.props.slidesToShow.xl
      });
    };
    this.setSlideToActive = function (i) {
      var visibleSlide = _this.getSlideByIndex(i);
      if (visibleSlide && !visibleSlide.classList.contains('slick-active')) {
        visibleSlide.classList.add('slick-active');
      }
    };
    this.setSlideToOverflow = function (i) {
      var overflowSlideLeft = _this.getSlideByIndex(i);
      if (overflowSlideLeft && _this.component.props.allowOverflow) {
        overflowSlideLeft.classList.add('overflow-slide');
      }
    };
    this.afterChange = function () {
      _this.setSlideToOverflow(_this.component.state.currentSlide - 1);
      if (_this.sliderHasRemainderSlides()) {
        _this.setSlideToOverflow(_this.slides.length - (_this.component.state.slidesToShow + 1));
        _this.onEachVisibleSlide([_this.setSlideToActive]);
      }
      _this.component.setState({
        transitioning: false
      });
    };
    this.removeAdditionalClasses = function (i) {
      var slide = _this.getSlideByIndex(i);
      var classesToRemove = ['overflow-slide'];
      if (!slide) return;
      classesToRemove.forEach(function (classToRemove) {
        if (slide.classList.contains(classToRemove)) {
          slide.classList.remove(classToRemove);
        }
      });
    };
    this.beforeChange = function () {
      _this.onEachSlide([_this.removeAdditionalClasses]);
      _this.component.setState({
        currentSlide: arguments.length <= 1 ? undefined : arguments[1],
        transitioning: true
      });
    };
    this.onResize = function (dots) {
      if (_this.component.sliderRef) {
        if (_this.currentResponsiveSetting) {
          _this.component.setState({
            slidesToShow: _this.currentResponsiveSetting.settings.slidesToShow,
            slidesToScroll: _this.currentResponsiveSetting.settings.slidesToScroll
          });
        } else {
          _this.component.setState({
            slidesToShow: _this.component.props.slidesToShow.xl,
            slidesToScroll: _this.component.props.slidesToScroll.xl || _this.component.props.slidesToShow.xl
          });
        }
      }
      if (dots && dots.length > _this.component.state.pagersToShow) {
        _this.component.setState({
          pagersToShow: dots.length
        });
      }
      return /*#__PURE__*/_react["default"].createElement(_react.Fragment);
    };
    this.component = component;
  }
  _createClass(SliderSettings, [{
    key: "settings",
    get: function get() {
      var _this$component$props2,
        _this$component$props3,
        _this2 = this;
      return {
        accessibility: true,
        arrows: false,
        autoplay: !!((_this$component$props2 = this.component.props.autoPlay) !== null && _this$component$props2 !== void 0 && _this$component$props2.active),
        autoplaySpeed: ((_this$component$props3 = this.component.props.autoPlay) === null || _this$component$props3 === void 0 ? void 0 : _this$component$props3.waitTime) || 3000,
        dots: true,
        draggable: true,
        focusOnSelect: false,
        infinite: this.component.props.infiniteLoop,
        initialSlide: this.component.props.startingSlide,
        speed: this.component.props.transitionSpeed,
        onInit: this.onSliderInit,
        onReInit: function onReInit() {
          return _this2.reInit();
        },
        afterChange: this.afterChange,
        beforeChange: this.beforeChange,
        slidesToShow: this.component.props.slidesToShow.xl,
        slidesToScroll: this.component.props.slidesToScroll.xl || this.component.props.slidesToShow.xl,
        responsive: this.responsiveSettings,
        appendDots: this.onResize,
        customPaging: function customPaging() {
          return /*#__PURE__*/_react["default"].createElement(_react.Fragment);
        }
      };
    }
  }, {
    key: "slides",
    get: function get() {
      if (this.component.sliderRef && Array.isArray(this.component.sliderRef.props.children)) {
        return this.component.sliderRef.props.children;
      }
      return [];
    }
  }, {
    key: "setSlidesToShow",
    value: function setSlidesToShow(slides) {
      this.component.setState({
        slidesToShow: slides
      });
    }
  }, {
    key: "reInit",
    value: function reInit() {
      // case when dots are shown and no infiniteLoop
      if (this.component.sliderRef && !this.component.props.infiniteLoop && this.isDotsShown && this.isDotsSameAsSlides) {
        // if all slides shown - remove dots
        if (this.compareSettingsSlidesToShow) {
          var _this$currentResponsi;
          this.setSlidesToShow((_this$currentResponsi = this.currentResponsiveSetting) === null || _this$currentResponsi === void 0 ? void 0 : _this$currentResponsi.settings.slidesToShow);
        }
        // if there is no breakpoint, all slides are shown we need to remove dots
        if (!this.currentBreakpoint) {
          this.setSlidesToShow(this.component.props.slidesToShow.xl);
        }
      }
      if (this.noBreakpointAndMaxSlides || this.settingsSlidesSameAsCurrent) {
        this.setSlidesToShow(this.component.props.slidesToShow.xl);
      }
      this.setSlideToOverflow(this.component.state.currentSlide - 1);
    }
  }, {
    key: "onEachVisibleSlide",
    value: function onEachVisibleSlide(callbacks) {
      var _loop = function _loop(i) {
        callbacks.forEach(function (callback) {
          callback(i);
        });
      };
      for (var i = this.slides.length - this.component.state.slidesToScroll; i < this.slides.length; i++) {
        _loop(i);
      }
    }
  }, {
    key: "onEachSlide",
    value: function onEachSlide(callbacks) {
      var _loop2 = function _loop2(i) {
        callbacks.forEach(function (callback) {
          callback(i);
        });
      };
      for (var i = 0; i < this.slides.length; i++) {
        _loop2(i);
      }
    }
  }, {
    key: "getSlideByIndex",
    value: function getSlideByIndex(i) {
      try {
        return document.querySelector("#".concat(this.component.props.id, " [data-index=\"").concat(i, "\"]"));
      } catch (_unused) {
        return null;
      }
    }
  }, {
    key: "sliderHasRemainderSlides",
    value: function sliderHasRemainderSlides() {
      return this.component.state.currentSlide + this.component.state.slidesToScroll >= this.slides.length;
    }
  }, {
    key: "currentBreakpoint",
    get: function get() {
      if (this.component.sliderRef) {
        // Ignoring TS as slider.state is not protected as a type
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        return this.component.sliderRef.state.breakpoint;
      }
    }
  }, {
    key: "isDotsSameAsSlides",
    get: function get() {
      return this.component.state.pagersToShow === this.slides.length;
    }
  }, {
    key: "compareSettingsSlidesToShow",
    get: function get() {
      var _this$currentResponsi2;
      return this.slides.length === ((_this$currentResponsi2 = this.currentResponsiveSetting) === null || _this$currentResponsi2 === void 0 ? void 0 : _this$currentResponsi2.settings.slidesToShow);
    }
  }, {
    key: "compareMaxSlidesToShow",
    get: function get() {
      return this.component.props.slidesToShow.xl === this.slides.length;
    }
  }, {
    key: "isDotsShown",
    get: function get() {
      return this.component.state.pagersToShow !== 0;
    }
  }, {
    key: "currentResponsiveSetting",
    get: function get() {
      var _this3 = this;
      return this.responsiveSettings.find(function (setting) {
        return setting.breakpoint === _this3.currentBreakpoint;
      });
    }
  }, {
    key: "responsiveSettings",
    get: function get() {
      var responsiveSettings = [];
      var breakpointIdentifiers = ['xl', 'lg', 'md', 'sm'];
      for (var i = 1; i < breakpointIdentifiers.length; i++) {
        var breakpointIdentifier = breakpointIdentifiers[i];
        var nextBreakpoint = breakpointIdentifiers[i - 1];
        if (this.component.props.slidesToShow[breakpointIdentifier]) {
          var slidesToScroll = this.component.props.slidesToScroll[breakpointIdentifier];
          var slidesToShow = this.component.props.slidesToShow[breakpointIdentifier];
          responsiveSettings.push({
            breakpoint: this.component.props.theme.breakpoints[nextBreakpoint],
            settings: {
              slidesToShow: slidesToShow,
              slidesToScroll: slidesToScroll || slidesToShow
            }
          });
        }
      }
      return responsiveSettings;
    }
  }, {
    key: "settingsSlidesSameAsCurrent",
    get: function get() {
      return this.compareSettingsSlidesToShow && this.isDotsShown;
    }
  }, {
    key: "noBreakpointAndMaxSlides",
    get: function get() {
      return !this.currentBreakpoint && this.compareMaxSlidesToShow && this.isDotsShown;
    }
  }, {
    key: "isFirstSlide",
    get: function get() {
      return this.component.state.currentSlide === 0;
    }
  }, {
    key: "isLastSlide",
    get: function get() {
      return this.component.state.currentSlide + this.component.state.slidesToShow >= this.slides.length;
    }
  }, {
    key: "invertedControls",
    get: function get() {
      var _this$component$props4;
      if (((_this$component$props4 = this.component.props.autoPlay) === null || _this$component$props4 === void 0 ? void 0 : _this$component$props4.invertControls) === undefined) return true;
      return this.component.props.autoPlay.invertControls;
    }
  }, {
    key: "showPreviousArrow",
    get: function get() {
      return this.component.props.infiniteLoop && this.component.state.pagersToShow !== 0 || !this.component.props.infiniteLoop && !this.isFirstSlide;
    }
  }, {
    key: "showNextArrow",
    get: function get() {
      return this.component.props.infiniteLoop && this.component.state.pagersToShow !== 0 || !this.component.props.infiniteLoop && !this.isLastSlide;
    }
  }]);
  return SliderSettings;
}();
exports["default"] = SliderSettings;
//# sourceMappingURL=SliderSettings.js.map